export default "__VITE_ASSET__CMPVR88q__"